import { render } from "./ProjectsAndSpaces.vue?vue&type=template&id=7b3e1488&scoped=true"
import script from "./ProjectsAndSpaces.vue?vue&type=script&lang=js"
export * from "./ProjectsAndSpaces.vue?vue&type=script&lang=js"

import "./ProjectsAndSpaces.vue?vue&type=style&index=0&id=7b3e1488&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3e1488"]])

export default __exports__